<template>
  <section class="content-block">
    <transition name="slide-fade-delay">
      <div
        v-if="active"
        class="block sub-footer is-flex"
      >
        <p>
          <a
            :href="$t('footer.imprintLink')"
            target="_blank"
          >{{ $t('footer.imprint') }}</a>
        </p>
        <p>
          <a
            :href="$t('footer.privacyLink')"
            target="_blank"
          >{{ $t('footer.privacy') }}</a>
        </p>
        <!--<p>-->
        <!--<a href="https://schladmingdachstein.traumgutscheine.com/shop_content.php/coID/3/content/AGB#navtrail_anchor"-->
        <!--target="_blank"-->
        <!--&gt;AGB</a>-->
        <!--</p>-->
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'Start',
  data () {
    return {
        active: false
    }
  },
  mounted () {
    this.active = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sub-footer {

  padding: 0px 0px;
  box-shadow: none;
  border: none;

  p {
    font-size: 0.7rem;
    font-weight: 500;
    cursor: pointer;
    margin-right: 18px;
    text-transform: uppercase;
    transition: all 0.3s ease-in-out;

    &:last-of-type {
      margin-right: 0;
    }

    &:hover {
      opacity: 0.75;
    }
  }
}

@media (max-width: 680px) {
  .sub-footer {
    margin-top: -5px;

    p {
      font-size: 0.6rem;
    }
  }
}
</style>
